import { render, staticRenderFns } from "./screening-task.vue?vue&type=template&id=4856b5f0&scoped=true"
import script from "./screening-task.vue?vue&type=script&lang=js"
export * from "./screening-task.vue?vue&type=script&lang=js"
import style0 from "./screening-task.vue?vue&type=style&index=0&id=4856b5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856b5f0",
  null
  
)

export default component.exports